import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {
  paymentList: any = [];
  show: boolean = false
  filterForm!: FormGroup;

  constructor(private formBuilder: FormBuilder, private paymentService: PaymentService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

    this.show = false
    this.spinner.show()
    this.paymentService.getPaymentDetails(null, null, null).subscribe(res => {

      this.paymentList=res.data;
      this.show = true
      this.spinner.hide();
    })

  

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
    }, { validator: this.dateLessThan('fromDate', 'toDate') });
  }
  dateLessThan(from: string, to: string) {
    return (group: FormGroup): {[key: string]: any} => {
      let f = group.controls[from];
      let t = group.controls[to];
      if (f.value && t.value && f.value > t.value) {
        return {
          dates: "To Date should be greater than From Date"
        };
      }
      return {};
    }
  }

  submitFilterForm() {
    this.spinner.show()
    this.paymentService.getPaymentDetails(null, this.filterForm.controls['fromDate'].value, this.filterForm.controls['toDate'].value).subscribe(res => {

      // res.data.forEach((element: any) => {
        
      //     this.paymentList.unshift(element)
        
      // });
      this.paymentList=res.data;
      this.show=true
      this.spinner.hide()
    })
  }

}
